import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "latest-transactions-carousel mb-4 mr-n2" }
const _hoisted_3 = { class: "d-flex flex-row-reverse align-center justify-space-between" }
const _hoisted_4 = ["textContent"]
const _hoisted_5 = { class: "d-flex flex-row-reverse align-center ga-2 pt-1" }
const _hoisted_6 = { class: "text-primary price" }
const _hoisted_7 = {
  dir: "ltr",
  style: {"width":"80%"}
}

import "vue3-carousel/dist/carousel.css";
// https://ismail9k.github.io/vue3-carousel/examples.html
import { Carousel, Slide } from "vue3-carousel";

import { useRoute } from "vue-router";
import { onMounted } from "vue";

import { TX_FUNCTIONS, ROUTE_SALE, ROUTE_HOME } from "@/utils/constants";
import { formatAddress } from "@/utils";
import { useLatestTransactions } from "@/composables";
import { TransactionsService } from "@/api/generated";
import { Decimal } from "@/libs/decimal";

import TextTruncate from "@/components/Common/TextTruncate.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'LatestTransactionsCarousel',
  setup(__props) {

const route = useRoute();
const { latestTransactions } = useLatestTransactions();

onMounted(() => {
  TransactionsService.listTransactions({
    limit: 10,
    includes: "token",
  }).then((response: any) => {
    latestTransactions.value = response.items;
  });
});

return (_ctx: any,_cache: any) => {
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_fade_transition = _resolveComponent("v-fade-transition")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_fade_transition, null, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(Carousel), {
            dir: "rtl",
            options: { currentPage: 0 },
            "snap-align": "start",
            autoplay: 2000,
            transition: 1000,
            "items-to-show": 4,
            breakpoints: {
            1680: { itemsToShow: 7 },
            1280: { itemsToShow: 5 },
            780: { itemsToShow: 3 },
            480: { itemsToShow: 2 },
            100: { itemsToShow: 1 },
          },
            "mouse-drag": false,
            "pause-autoplay-on-hover": ""
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(latestTransactions), (transaction) => {
                return (_openBlock(), _createBlock(_unref(Slide), {
                  key: transaction.hash
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, {
                      class: "mr-2 latest-trades-item",
                      to: {
                name: _unref(ROUTE_SALE),
                params: { contractAddress: transaction.token.sale_address },
              }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card_text, { class: "py-2 px-2" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_3, [
                              _createElementVNode("span", {
                                textContent: _toDisplayString(_unref(formatAddress)(transaction.address)),
                                class: "opacity-80"
                              }, null, 8, _hoisted_4),
                              _createVNode(_component_v_chip, {
                                class: "font-heading tx-type-chip",
                                color: 
                      transaction.tx_type === _unref(TX_FUNCTIONS).sell
                        ? 'error'
                        : 'success'
                    
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(transaction.tx_type === _unref(TX_FUNCTIONS).sell
                        ? "sold"
                        : "bought"), 1)
                                ]),
                                _: 2
                              }, 1032, ["color"])
                            ]),
                            _createElementVNode("div", _hoisted_5, [
                              _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(Decimal).from(transaction?.volume).shorten()), 1),
                              _createElementVNode("div", _hoisted_7, [
                                _createVNode(TextTruncate, {
                                  str: transaction.token.name,
                                  class: "symbol font-heading"
                                }, null, 8, ["str"])
                              ])
                            ])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ], 512), [
          [_vShow, 
          [_unref(ROUTE_HOME), _unref(ROUTE_SALE)].includes(_unref(route).name) &&
          _unref(latestTransactions).length
        ]
        ])
      ]),
      _: 1
    })
  ]))
}
}

})